import {weakMemo} from '@packages/utilities/memo';
import * as React from 'react';

const defaultValue = {
  top: 0,
  left: 0,
  width: 0,
  height: 0,
  x: 0,
  y: 0,
};

export const ViewportContext: React.Context<typeof defaultValue> =
  React.createContext(defaultValue);

ViewportContext.displayName = 'ViewportContext';

type Box = {
  top: number;
  left: number;
  width: number;
  height: number;
  x?: number;
  y?: number;
};

type Props = {
  box: Box | undefined;
  children: React.ReactNode;
};

function calculateViewportBox(box: Box) {
  return {
    ...box,
    x: box.left,
    y: box.top,
  };
}

const memoizedCalculateViewportBox = weakMemo(calculateViewportBox);

export const Viewport = ({box = defaultValue, children}: Props) => {
  const domRectBox = memoizedCalculateViewportBox(box);

  return (
    <ViewportContext.Provider value={domRectBox}>
      {children}
    </ViewportContext.Provider>
  );
};

Viewport.displayName = 'Viewport';

export const useViewport = () => React.useContext(ViewportContext);
